var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesPolls(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EDF1F7",
    d: "M62 31c0 17.12-13.88 31-31 31C13.88 62 0 48.12 0 31 0 13.878 13.88 0 31 0c17.12 0 31 13.878 31 31",
    transform: "translate(-444 -858) translate(444 858) translate(13 13)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8E97FC",
    d: "M27 1.096C27 .49 26.502 0 25.893 0H15.107C14.498 0 14 .49 14 1.096V45h13V1.096z",
    transform: "translate(-444 -858) translate(444 858) translate(13 13) translate(3 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3677D6",
    d: "M41 21.096C41 20.49 40.502 20 39.893 20H29.107c-.609 0-1.107.49-1.107 1.096V45h13V21.096z",
    transform: "translate(-444 -858) translate(444 858) translate(13 13) translate(3 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC727",
    d: "M13 45V33.105C13 32.5 12.502 32 11.893 32H1.107C.497 32 0 32.499 0 33.105V45h13z",
    transform: "translate(-444 -858) translate(444 858) translate(13 13) translate(3 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7EB2EA",
    d: "M55 45V13.105C55 12.5 54.502 12 53.893 12H43.107c-.61 0-1.107.499-1.107 1.105V45h13z",
    transform: "translate(-444 -858) translate(444 858) translate(13 13) translate(3 8)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H88V88H0z",
    transform: "translate(-444 -858) translate(444 858)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesPolls);
export default __webpack_public_path__ + "static/media/features-polls.3da8c74e.svg";
export { ForwardRef as ReactComponent };